import { hide, show } from "../utils/helpers";
import TieredBillingTypeEditor from "./tiered-billing-type-editor";

export default class CatalogPlanAddOn {
  constructor() {
    this.form = document.querySelector('#catalog_update_plan_add_on');
    if (this.form) {
      this.validator = window.solodev.formValidators[this.form.id];
      // This is callback called by header button.
      window.solodev.submitForm = () => this.form.submit();

      this.billingCyclePaymentInput = document.querySelector('#catalog_update_plan_add_on_billing_cycle_payment');
      this.billingTypeCnt = document.querySelector('.js-billing-type');
      this.billingTypeInput = this.billingTypeCnt.querySelector('select');
      this.priceCnt = document.querySelector('.js-price');
      this.tieredPricingInput = document.querySelector('#catalog_update_plan_add_on_billing_type_config');
      this.tieredBillingTypeCnt = document.querySelector('.js-tiered-billing-type');
      this.tieredBillingTypeEditor = new TieredBillingTypeEditor({
        propsData: {
          input: this.tieredPricingInput,
          validationApiEndpoint: this.form.dataset.validationApi,
        },
        el: this.tieredBillingTypeCnt.children[0],
      });

      this.billingCyclePaymentInput.addEventListener('change', this.updateLayout.bind(this));
      this.billingTypeInput.addEventListener('change', this.updateLayout.bind(this));
      this.updateLayout();
      this.initValidation();
    }
  }

  initValidation() {
    this.validator.addFieldValidation('catalog_update_plan_add_on[usage_unit]', (value, resolve, reject) => {
      if (this.billingCyclePaymentInput.value === 'at-the-end' && !value) {
        reject('This value should not be blank.');
      } else {
        resolve();
      }
    });
  }

  updateLayout() {
    // Reset visibility of all fields.
    hide(this.billingTypeCnt, this.priceCnt, this.tieredBillingTypeCnt);

    switch (this.billingCyclePaymentInput.value) {
      case 'at-the-beginning':
        show(this.billingTypeCnt);

        switch (this.billingTypeInput.value) {
          case 'fixed':
            show(this.priceCnt);
            break;
          case 'tiered':
            show(this.tieredBillingTypeCnt);
            break;
        }
        break;
      case 'at-the-end':
        show(this.billingTypeCnt);

        switch (this.billingTypeInput.value) {
          case 'fixed':
            show(this.priceCnt);
            break;
          case 'tiered':
            show(this.tieredBillingTypeCnt);
            break;
        }
        break;
    }
  }
}
